/**
 * Default report date ranges.
 *
 * Both transactional and performance ranges default to YEAR-TO-DATE, ending on
 * the most recent BUSINESS DAY WITH DATA (the lake's MAX as_of_date, via
 * ./lib/reportDates). A transactional range begins on January 1 (its activity
 * includes that day); a performance range begins on December 31 of the prior
 * year, the year-end close its return is measured from, so the year's first day
 * is linked as the Performance Summary's YTD links it. Historical begin dates
 * serve real data through the id-seam read-time translation, so a YTD default is
 * meaningful for every report family.
 */
import { firstOfDataYear, lastOfPriorDataYear, defaultReportDate } from './lib/reportDates';

/** { start, end } for transactional reports: Jan 1 (data year) .. latest business day. */
export const transactionalDefaultRange = () => ({
  start: firstOfDataYear(),
  end: defaultReportDate(),
});

/** { start, end } for performance reports: Dec 31 (prior data year) .. latest business day. */
export const performanceDefaultRange = () => ({
  start: lastOfPriorDataYear(),
  end: defaultReportDate(),
});
